import React, { useEffect, useState } from "react";
import { Provider as JotaiProvider, useAtom, useSetAtom } from "jotai";
import { Container } from "components/Container";
import {Botones} from "./componentes/botones";
import TablaHorarios from "./componentes/tabla-horarios/TablaHorarios";

const ListarHorariosPage = () => {
  return (
    <JotaiProvider>
      <Container titulo="Bandeja de Horarios" botonExtra={<Botones/>}>
           <TablaHorarios/>
           {/*<ModalRechazarSolicitudVacaciones/> */}
        </Container>
    </JotaiProvider>
  )
}

export default ListarHorariosPage;